import * as React from 'react';
import { DatasheetElement, DatasheetElementId } from "@modules/datasheets/types/datasheet-element";
import { DatasheetHolderSelectionBox } from './components/datasheet-holder/datasheet-holder.types';
import { IDatasheetComponentDto } from '@common/dto/datasheet/datasheet-component';
import { DatasheetFieldComponentGetDto } from '@common/dto/datasheet/field-component/get-dto';
import { DatasheetLocalGetDto } from '../../types/datasheet';
import { FieldPickerField } from '../field-picker/components/fields/fields.types';

export type DatasheetProps = {
  gridSettingsMargin: {
    show: boolean;
    width: number;
    height: number;
  };
  pageBreaks: {
    show: boolean;
    width: number;
    height: number;
  };
  datasheet: DatasheetLocalGetDto;
  datasheetElements: Array<DatasheetElement>;
  className?: string;
  datasheetElementDragType: string;
  selectedDatasheetElementsCount: number;
  printableDatasheetHolderId: string;
  onTabOrderChange: (datasheetElement: DatasheetElement<DatasheetFieldComponentGetDto>) => void;
  onDatasheetElementSelect: <T extends IDatasheetComponentDto = IDatasheetComponentDto>(datasheetElement: DatasheetElement<T>, e: React.MouseEvent<HTMLDivElement>) => void;
  isDatasheetElementSelected: <T extends IDatasheetComponentDto = IDatasheetComponentDto>(datasheetElement: DatasheetElement<T>) => boolean;
  onDatasheetElementUpdate: <T extends IDatasheetComponentDto = IDatasheetComponentDto>(
    datasheetElementId: DatasheetElementId, 
    data: Partial<DatasheetElement<T>>
  ) => void;
  onDatasheetElementMove: <T extends IDatasheetComponentDto = IDatasheetComponentDto>(
    datasheetElementId: DatasheetElementId, 
    data: Partial<DatasheetElement<T>>
  ) => void;
  onDatasheetElementResize: <T extends IDatasheetComponentDto = IDatasheetComponentDto>(
    datasheetElementId: DatasheetElementId, 
    data: Partial<DatasheetElement<T>>
  ) => void;
  onSelectionReset: () => void;
  onSelectionEnd: (selection: DatasheetHolderSelectionBox) => void;
  onDatasheetElementsDrop: (params: { firstDatasheetElementCoordinates: { y: number; x: number; }; draggedField?: FieldPickerField }) => void;
};

export const useDatasheetController = (props: DatasheetProps) => {
  const datasheetReference = React.useRef<HTMLDivElement>(null);

  return {
    datasheetReference
  };
};